<template lang="pug">
div
  .px-10
    .termo-compromisso
      termo-compromisso(v-if="!isReurb")
      termo-compromisso-reurb(v-if="isReurb")
    .container-checkbox
      el-checkbox(disabled, v-model='confirmado')
      span.greenText {{termoAceito}}
</template>
<script>
import { mapState } from 'vuex'
const TermoCompromisso = () => import('@/components/estados/' + process.env.ESTADO + '/TermoCompromisso')
const TermoCompromissoReurb = () => import('@/components/estados/' + process.env.ESTADO + '/TermoCompromissoReurb')

export default {
  props: {
    isReurb: {
      type: Boolean,
      required: false
    },
    isCancelamentoClausulaResolutiva: {
      type: Boolean,
      required: false
    },
    isProcessoFisico: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      confirmado: true,
      termoOffile: 'Declaro que li e estou de acordo com os termos acima e tenho ciência que ao finalizar este cadastro ainda será necessário enviá-lo ao ORGAO para iniciar o processo de regularização.',
      termoReurb: 'Declaro que li e estou de acordo com as informações declaradas no formulário.',
      termoCancelamentoClausulaResolutiva: 'Declaro que li e estou de acordo com os termos acima e tenho ciência que ao finalizar este cadastro ele será enviado automaticamente para o ITERMA para início do processo de cancelamento.',
      termoProcessoFisico: 'Declaro que li e estou de acordo com os termos acima e tenho ciência que ao finalizar este cadastro ele será enviado automaticamente para o ITERMA para início do processo de regularização.'
    }
  },

  components: {
    TermoCompromisso,
    TermoCompromissoReurb
  },

  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO,
      SISTEMA: state => state.userInterface.dadosEstado.SISTEMA
    }),

    termoAceito () {
      if (this?.isCancelamentoClausulaResolutiva) {
        return this.termoCancelamentoClausulaResolutiva
      }
      if (this.isProcessoFisico) {
        return this.termoProcessoFisico
      }
      return this.isReurb ? this.termoReurb : this.termoOffile.replace('ORGAO', this.ORGAO)
    }
  }
}
</script>
<style lang="scss" scoped>
.pad5 {
  padding: 10px 0;
}
.px-10 {
  padding: 0 10px;
}
// @import '../../assets/styles/variables.scss'; Está carregando todo o node_module do element

$--color-primary: #009f61; // Importar o variables e retirar esta variavel quando juntar com o analise
$font-color: #606266;
$font-size-small: 0.875em;

.buttons {
  display: flex;
  justify-content: space-between;
}

.margin-top {
  margin-top: 10px;
}

.margin-right {
  margin-right: 10px;
}

.container-checkbox {
  margin-top: 10px;

  .el-checkbox {
    padding-right: 10px;
  }

  span {
    color: $font-color;
    font-size: $font-size-small;

    &.checked {
      color: $--color-primary;
    }
  }
}

.termo-compromisso {
  margin-top: 20px;
  padding: 10px;
  background-color: #f3f7fa;
  border-radius: 4px;
}

.greenText {
  color: #009f61;
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesTermoCompromisso.vue